// cleanup_convert_to_glu_component_GENERICS
// cleanup_convert_to_typescript_file_GENERICS

import React from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from '@glu/dropdown-react';

import ListPillCustomLink from './ListPillCustomLink';
import useStyles from './listPill.styles';

export const ListPillComponent = ({
  dataQa,
  disabled,
  enableSearch,
  htmlId,
  labelText,
  links,
  onChange: onCustomChange,
  optionLinkRole,
  state
}) => {
  const { reactDropdown } = useStyles();
  const [dropdownPlaceholder, ...rest] = links;
  const list = rest.map((obj) => ({ ...obj, id: obj.name, dataQa: obj?.dataQa }));
  return (
    <div data-qa={dataQa} className="list-pill">
      <Dropdown
        filterEnabled={enableSearch}
        className={reactDropdown}
        placeholder={dropdownPlaceholder.name}
        options={list}
        optionComponent={(params) => (
          <ListPillCustomLink
            state={state}
            params={params}
            onChange={onCustomChange}
            linkRole={optionLinkRole}
          />
        )}
        name="dropdown"
        htmlId={htmlId}
        value={[{ id: '', name: '' }]} // because we don't want to show the value of the dropdown in the view
        labelText={labelText}
        screenReaderLabel
        disabled={disabled}
      />
    </div>
  );
};

ListPillComponent.propTypes = {
  dataQa: PropTypes.string,
  disabled: PropTypes.bool,
  enableSearch: PropTypes.bool,
  htmlId: PropTypes.string,
  labelText: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string
    })
  ).isRequired,
  onChange: PropTypes.func,
  state: PropTypes.shape({}),
  styleOverride: PropTypes.shape({}),
  optionLinkRole: PropTypes.string
};

ListPillComponent.defaultProps = {
  dataQa: 'list-pill',
  disabled: false,
  enableSearch: false,
  htmlId: 'dropdown',
  labelText: 'dropdown',
  onChange() {},
  state: {},
  styleOverride: {},
  optionLinkRole: undefined
};

export default ListPillComponent;
